import { useState } from 'react';
import { CreateCaseRequest, UpdateCaseRequest, AddNoteRequest, AddContactRequest } from '../services/api';

export const useModals = () => {
  // New Case Modal
  const [isNewCaseModalOpen, setIsNewCaseModalOpen] = useState(false);
  const [newCaseData, setNewCaseData] = useState<CreateCaseRequest>({
    projectName: '',
    clientName: '',
    status: 'Open',
    phase: 'Initial',
    description: '',
  });
  const [isCreatingCase, setIsCreatingCase] = useState(false);

  // Edit Case Modal
  const [isEditModalOpen, setIsEditModalOpen] = useState(false);
  const [editData, setEditData] = useState<UpdateCaseRequest>({});
  const [isUpdating, setIsUpdating] = useState(false);

  // Upload Document Modal
  const [isUploadDocModalOpen, setIsUploadDocModalOpen] = useState(false);
  const [selectedDocFile, setSelectedDocFile] = useState<File | null>(null);
  const [isUploadingDoc, setIsUploadingDoc] = useState(false);
  const [uploadDocProgress, setUploadDocProgress] = useState<string>('');

  // Add Note Modal
  const [isNoteModalOpen, setIsNoteModalOpen] = useState(false);
  const [noteData, setNoteData] = useState<AddNoteRequest>({ body: '', typeTag: 'Note' });
  const [isAddingNote, setIsAddingNote] = useState(false);

  // Add Contact Modal
  const [isContactModalOpen, setIsContactModalOpen] = useState(false);
  const [contactData, setContactData] = useState<AddContactRequest>({ name: '', role: '' });
  const [isAddingContact, setIsAddingContact] = useState(false);

  // Document Preview Modal
  const [previewDocument, setPreviewDocument] = useState<{
    fileName: string;
    fileType: string;
    downloadUrl: string;
    docId: string;
  } | null>(null);

  const resetNewCaseModal = () => {
    setNewCaseData({
      projectName: '',
      clientName: '',
      status: 'Open',
      phase: 'Initial',
      description: '',
    });
    setIsNewCaseModalOpen(false);
  };

  const resetNoteModal = () => {
    setNoteData({ body: '', typeTag: 'Note' });
    setIsNoteModalOpen(false);
  };

  const resetContactModal = () => {
    setContactData({ name: '', role: '' });
    setIsContactModalOpen(false);
  };

  const resetUploadModal = () => {
    setSelectedDocFile(null);
    setUploadDocProgress('');
    setIsUploadDocModalOpen(false);
  };

  return {
    // New Case Modal
    isNewCaseModalOpen,
    setIsNewCaseModalOpen,
    newCaseData,
    setNewCaseData,
    isCreatingCase,
    setIsCreatingCase,
    resetNewCaseModal,

    // Edit Case Modal
    isEditModalOpen,
    setIsEditModalOpen,
    editData,
    setEditData,
    isUpdating,
    setIsUpdating,

    // Upload Document Modal
    isUploadDocModalOpen,
    setIsUploadDocModalOpen,
    selectedDocFile,
    setSelectedDocFile,
    isUploadingDoc,
    setIsUploadingDoc,
    uploadDocProgress,
    setUploadDocProgress,
    resetUploadModal,

    // Add Note Modal
    isNoteModalOpen,
    setIsNoteModalOpen,
    noteData,
    setNoteData,
    isAddingNote,
    setIsAddingNote,
    resetNoteModal,

    // Add Contact Modal
    isContactModalOpen,
    setIsContactModalOpen,
    contactData,
    setContactData,
    isAddingContact,
    setIsAddingContact,
    resetContactModal,

    // Document Preview Modal
    previewDocument,
    setPreviewDocument,
  };
};

